/**
 * EASE Nervensystem-Quiz — Shopify Section
 * Submits leads via native {% form 'customer' %} (tags + marketing), same pattern as newsletter-form.liquid
 */
(function () {
  'use strict';

  const ICONS = {
    bolt: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M13 2L4 14h6l-1 8 9-12h-6l1-8Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    clock:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    tap: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 13.5V8.8a1.8 1.8 0 1 1 3.6 0v4.3M11.6 13.1V7.9a1.8 1.8 0 1 1 3.6 0v5.2M15.2 13.9V9.6a1.8 1.8 0 1 1 3.6 0v6.2c0 2.9-2.3 5.2-5.2 5.2H11c-1.5 0-2.8-.7-3.8-1.8l-1.6-1.9a1.8 1.8 0 1 1 2.7-2.4L9.8 16" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2.5" stroke="currentColor" stroke-width="1.8"/><path d="M8 10V7.5a4 4 0 1 1 8 0V10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="15" r="1.3" fill="currentColor"/></svg>',
    swirl:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M18.5 8.5a6.5 6.5 0 1 0-6.5 6.5c2.5 0 4.5 2 4.5 4.5S14.5 24 12 24" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M5.5 15.5a6.5 6.5 0 1 0 6.5-6.5c-2.5 0-4.5-2-4.5-4.5S9.5 0 12 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20.3 14.2A8.5 8.5 0 1 1 9.8 3.7a7 7 0 1 0 10.5 10.5Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    neck: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 4c0 2 1.2 3.1 4 3.1S16 6 16 4M9.3 7.1v4.1l-2.5 3.1M14.7 7.1v4.1l2.5 3.1M6 17h12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    fatigue:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M8.3 10.2h2.2M13.5 10.2h2.2M8.8 15c1-.8 2-.8 3.2 0 1.2-.8 2.2-.8 3.2 0" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    focus:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="2.4" stroke="currentColor" stroke-width="1.8"/><path d="M12 3v2.7M12 18.3V21M3 12h2.7M18.3 12H21M5.6 5.6l1.9 1.9M16.5 16.5l1.9 1.9M18.4 5.6l-1.9 1.9M7.5 16.5l-1.9 1.9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    calendar:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="5.5" width="17" height="15" rx="2.5" stroke="currentColor" stroke-width="1.8"/><path d="M7.5 3.5v4M16.5 3.5v4M3.5 9.5h17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    calendarRange:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="5.5" width="17" height="15" rx="2.5" stroke="currentColor" stroke-width="1.8"/><path d="M7.5 3.5v4M16.5 3.5v4M3.5 9.5h17M8 13h3M13 16h3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    infinity:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9.2 9.2c-1.7-1.7-4.5-1.7-6.2 0-1.7 1.7-1.7 4.5 0 6.2 1.7 1.7 4.5 1.7 6.2 0l5.6-5.6c1.7-1.7 4.5-1.7 6.2 0 1.7 1.7 1.7 4.5 0 6.2-1.7 1.7-4.5 1.7-6.2 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    head: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3.5c-3 0-5.5 2.5-5.5 5.5v2.2L5 13v2h2.2v1.6c0 2.7 2.2 4.9 4.8 4.9 2.7 0 4.9-2.2 4.9-4.9V15H19v-2l-1.5-1.8V9c0-3-2.5-5.5-5.5-5.5Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    shoulder:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 16c0-2.8 2.2-5 5-5h2c2.8 0 5 2.2 5 5M12 4.2a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    jaw: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9.5c0-3.3 2.7-6 6-6s6 2.7 6 6v1.8c0 4-2.7 8.2-6 8.2s-6-4.2-6-8.2V9.5Z" stroke="currentColor" stroke-width="1.8"/><path d="M9.2 9.5h5.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    gut: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.5 4.5c0 2.1-1.7 3-3 4.3-1.2 1.2-2 2.9-2 4.7 0 3.3 2.7 6 6 6h.8c2 0 3.7-1.6 3.7-3.6V8.1c0-2 1.6-3.6 3.6-3.6h1.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    checkCircle:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="m8.2 12.3 2.4 2.4 5.2-5.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    meditate:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="5.2" r="2.2" stroke="currentColor" stroke-width="1.7"/><path d="M7.5 12.5 10.8 10h2.4l3.3 2.5M8.2 17.5l2.2-2.2h3.2l2.2 2.2M6 20h12" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    run: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="14.6" cy="4.8" r="2" stroke="currentColor" stroke-width="1.7"/><path d="m10.5 10 2.2-2.2 3 1.2M11 20l1.2-5.3-2.7-2.2L7 14M15.8 20l-1.1-3.9 2.4-2.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    pill: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="8" width="16" height="8" rx="4" stroke="currentColor" stroke-width="1.8"/><path d="m9.4 10.2 5.2 3.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="8" r="3.2" stroke="currentColor" stroke-width="1.8"/><path d="M5.2 19.5c1.5-2.4 3.7-3.6 6.8-3.6 3.1 0 5.3 1.2 6.8 3.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    spark:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3.8v4M12 16.2v4M3.8 12h4M16.2 12h4M6.1 6.1l2.8 2.8M15.1 15.1l2.8 2.8M17.9 6.1l-2.8 2.8M8.9 15.1l-2.8 2.8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    warning:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 4.2 20.2 19H3.8L12 4.2Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 9.4v5.2M12 17.4h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    heartBreak:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12.8 5.3 10 10h3l-2 4.2 5.8-6.7h-3.2l2-2.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 20.2C5.7 16.4 3.3 12.6 4.8 9.2 6 6.5 9.3 5.5 12 7.4c2.7-1.9 6-1 7.2 1.8 1.5 3.4-.9 7.2-7.2 11Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>',
    veryHappy:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M8.2 10.2h.01M15.8 10.2h.01M8 13.8c1.1 1.6 2.4 2.3 4 2.3s2.9-.7 4-2.3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    calm:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M8.2 10.2h.01M15.8 10.2h.01M8.5 14.2c1 .8 2 1.2 3.5 1.2s2.5-.4 3.5-1.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    neutral:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M8.2 10.2h.01M15.8 10.2h.01M9 14.4h6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    tense:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M8.2 10.2h.01M15.8 10.2h.01M8.8 15.2c1.1-1 2.2-1.4 3.2-1.4 1 0 2.1.4 3.2 1.4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    stressed:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M8.2 10.2h.01M15.8 10.2h.01M9 15.3c1.1-1.4 2.1-2 3-2s1.9.6 3 2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    overwhelmed:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M8 10.1 9.7 11.8M9.7 10.1 8 11.8M14.3 10.1 16 11.8M16 10.1l-1.7 1.7M8.8 15.8c1.1-1.2 2.2-1.7 3.2-1.7 1 0 2.1.5 3.2 1.7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    zen: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 15c1.4 1.2 3.1 1.8 6 1.8S16.6 16.2 18 15M7 9.8h3M14 9.8h3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/></svg>',
    relax: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4.5 12c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4.5 16.2c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    energy:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2v5.4M12 16.6V22M4.2 4.2l3.9 3.9M15.9 15.9l3.9 3.9M2 12h5.4M16.6 12H22M4.2 19.8l3.9-3.9M15.9 8.1l3.9-3.9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    brain:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.2 8.8a3 3 0 0 1 6 0v6.4a3 3 0 1 1-6 0V8.8ZM6.2 10.2a2.3 2.3 0 1 1 0 4.6M17.8 10.2a2.3 2.3 0 1 0 0 4.6M9.4 6.2a2.4 2.4 0 1 1 4.8 0" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20.2C5.7 16.4 3.3 12.6 4.8 9.2 6 6.5 9.3 5.5 12 7.4c2.7-1.9 6-1 7.2 1.8 1.5 3.4-.9 7.2-7.2 11Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    muscle:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 14c0 3 2.2 5 5.2 5h2.3c1.9 0 3.5-1.5 3.5-3.5v-1.3c0-2.3-1.8-4.2-4.2-4.2H12l-1.8-2.7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 4c-7 .3-12 4.8-12 11.4v4.6M20 4c-1.2 6.9-5.2 11-12 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    hand: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 13V8.8a1.8 1.8 0 1 1 3.6 0v4.2M11.6 12.8V7.7a1.8 1.8 0 1 1 3.6 0v5.1M15.2 13.4V9.4a1.8 1.8 0 1 1 3.6 0v6.5c0 2.8-2.3 5.1-5.1 5.1H11c-1.5 0-2.8-.7-3.8-1.8l-1.6-2a1.8 1.8 0 1 1 2.8-2.3L10 16" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    wave: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 12c2.6 0 2.6-3 5.2-3s2.6 3 5.2 3 2.6-3 5.2-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M3 17c2.6 0 2.6-3 5.2-3s2.6 3 5.2 3 2.6-3 5.2-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    target:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="4.2" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21s6-5.7 6-11a6 6 0 1 0-12 0c0 5.3 6 11 6 11Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="12" cy="10" r="2.2" stroke="currentColor" stroke-width="1.7"/></svg>',
    dots: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="6" cy="12" r="1.9" fill="currentColor"/><circle cx="12" cy="12" r="1.9" fill="currentColor"/><circle cx="18" cy="12" r="1.9" fill="currentColor"/></svg>',
  };

  function iconSvg(name) {
    return ICONS[name] || ICONS.spark;
  }

  const EINBLICK1_LIBRARY = {
    q1_echo: {
      schlaf: 'Schlafprobleme',
      unruhe: 'ständige Unruhe',
      verspannung: 'Nacken-Verspannung',
      erschoepfung: 'Erschöpfung',
      konzentration: 'Konzentrations-Mühe',
      angst: 'Anspannung',
    },
    q3_echo: {
      wochen: 'seit ein paar Wochen',
      monate: 'seit Monaten',
      jahr: 'seit über einem Jahr',
      immer: 'so lange du dich erinnern kannst',
    },
    trigger_line: {
      morgen: 'am stärksten morgens',
      job: 'unter Druck im Job',
      abend: 'abends, wenn du runterkommen willst',
      nacht: 'nachts mit Aufwachen',
      termin: 'vor wichtigen Terminen',
    },
    stat: {
      schlaf: {
        num: '78 %',
        label:
          'der Menschen mit <strong>genau dieser Kombination</strong> berichten, dass sie zwischen 2 und 4 Uhr aufwachen – dem körpereigenen Cortisol-Hochpunkt.',
      },
      unruhe: {
        num: '2 von 3',
        label: 'Erwachsenen berichten von chronischer innerer Unruhe – ohne es als „Stress" zu erkennen.',
      },
      verspannung: {
        num: '70 %',
        label:
          'der Spannungskopfschmerzen entstehen nicht in der Muskulatur – sondern durch ein NS, das nicht abschalten kann.',
      },
      erschoepfung: {
        num: 'Müde trotz Schlaf',
        label: 'ist das häufigste Zeichen für Nervensystem-Überlastung. Dein Körper schläft, der Sympathikus läuft weiter.',
      },
      konzentration: {
        num: 'Überstimulierung',
        label: 'verhindert klare Gedanken – nicht Disziplinmangel. Das Gehirn priorisiert dann Überleben statt Fokus.',
      },
      angst: {
        num: 'Vagusnerv',
        label: 'läuft bei chronischer Anspannung auf Sparflamme – Beruhigung wird ohne Aktivierung fast unmöglich.',
      },
      default: {
        num: '78 %',
        label: 'der Menschen berichten, dass sich erste Effekte nach wenigen Wochen Akupressur zeigen.',
      },
    },
    insight: {
      schlaf:
        'Das ist eines der klarsten Muster für einen festgefahrenen Sympathikus: dein Körper schaltet nachts nicht in den Reparatur-Modus, weil dein Nervensystem den Tag-Nacht-Rhythmus verloren hat.',
      unruhe:
        'Dein Körper sendet das Signal — Gedankenkreisen ist Folge, nicht Ursache. Ein dauerhaft aktivierter Sympathikus hält den Geist „in Habachtstellung".',
      verspannung:
        'Wenn der Kopf nicht loslässt, hält der Körper die Spannung. Massagen helfen kurz — solange dein NS nicht abschaltet, kehrt die Spannung wieder.',
      erschoepfung:
        'Dein Körper schläft, aber dein Sympathikus läuft weiter. Echte Erholung braucht den Parasympathikus — und der schaltet bei Dauer-Stress kaum noch ein.',
      konzentration:
        'Wenn der Kopf voll ist, bleibt kein Platz für klare Gedanken. Das ist kein Charakterzug — das ist Überstimulierung deines Nervensystems.',
      angst:
        'Bei chronischer Anspannung läuft der Vagusnerv (die „Bremse" deines NS) auf Sparflamme. Beruhigung wird ohne Aktivierung fast unmöglich.',
      default: 'Stress wirkt anders bei jedem. Die Mechanik dahinter aber: ein Nervensystem, das den Aus-Schalter verlernt hat.',
    },
    reframe: {
      schlaf:
        'Das ist nicht psychisch. Es ist auch keine Disziplin-Frage. Das ist ein Vagusnerv, der die nötige Aktivierungs-Übung verlernt hat – und genau diese Übung lässt sich mechanisch nachholen.',
      unruhe: 'Das ist nicht „so bin ich halt". Es ist ein Sympathikus, der im Dauer-Alarm-Modus festhängt — das lässt sich umkehren.',
      verspannung: 'Das ist keine schlechte Matratze. Es ist ein Körper, der nachts in Habachtstellung bleibt. Akupressur kann ihn dort abholen.',
      erschoepfung: 'Das ist nicht Faulheit. Es ist ein Nervensystem ohne Bremse. Sobald die Bremse zurück ist, kommt die Energie zurück.',
      konzentration: 'Das ist nicht „zu doof". Es ist ein NS, das gerade Überleben über Fokus stellt. Wir können das umtrainieren.',
      angst: 'Du bist nicht „zu empfindlich". Dein NS hat den Aus-Schalter nie wirklich gelernt — und kann ihn nachlernen.',
      default: 'Das ist nicht „so", weil du etwas falsch machst. Das ist ein NS-Muster — und Muster lassen sich verändern.',
    },
  };

  const EINBLICK2_LIBRARY = {
    tried_echo: {
      meditation: 'Meditation',
      sport: 'Sport',
      supplements: 'Supplements',
      therapie: 'Therapie',
    },
    time_label: {
      morgen: 'morgens, direkt nach dem Aufwachen',
      job: 'tagsüber, vor Stress-Spitzen',
      abend: 'abends, 20 Min. vor dem Schlafen',
      nacht: 'nachts, beim Aufwachen statt aufstehen',
      termin: '10 Min. vor wichtigen Terminen',
    },
    tone_by_impact: {
      wenig: 'Du machst schon vieles richtig – jetzt fehlt nur noch das richtige Werkzeug.',
      mittel: 'Das ist ein guter Zeitpunkt – noch ist Spielraum, bevor es chronisch wird.',
      stark: 'Du verdienst es, dich wieder wie du selbst zu fühlen – und du brauchst kein 8-Wochen-Programm dafür.',
      extrem: 'Wenn du am Limit bist, brauchst du etwas, das in 2 Minuten greift – und immer dabei ist.',
    },
  };

  const TIME_BOX_TEXTS = {
    morgen: 'Direkt nach dem Aufwachen, 3 Min. am Brustbein für einen ruhigen Tagesstart.',
    job: 'In der Mittagspause oder 5 Min. vor Meetings – diskret und schnell.',
    abend: 'Abends, 20 Min. vor dem Schlafengehen – als Wind-down-Routine.',
    nacht: 'Beim nächtlichen Aufwachen: 2 Min. am KG17 statt aufzustehen.',
    termin: '10 Min. vor wichtigen Situationen – am Handgelenk (HT7) oder Brustbein (KG17).',
  };

  function formatList(arr) {
    const andWord = quizUiEn && quizUiEn.and ? quizUiEn.and : 'und';
    const little = quizUiEn && quizUiEn.little ? quizUiEn.little : 'wenig';
    if (!arr || arr.length === 0) return little;
    if (arr.length === 1) return arr[0];
    if (arr.length === 2) return arr.join(` ${andWord} `);
    return arr.slice(0, -1).join(', ') + ` ${andWord} ` + arr[arr.length - 1];
  }

  function formatBodyAreas(arr) {
    const map =
      quizUiEn && quizUiEn.bodyAreas
        ? quizUiEn.bodyAreas
        : { kopf: 'Kopf', nacken: 'Nacken', kiefer: 'Kiefer', bauch: 'Bauch' };
    const filtered = (arr || []).filter((x) => x !== 'nichts').map((x) => map[x]).filter(Boolean);
    const fallbackBody = quizUiEn && quizUiEn.bodyFallback ? quizUiEn.bodyFallback : 'deinem Körper';
    return formatList(filtered) || fallbackBody;
  }

  function buildLayerInsight(tried) {
    const li = quizUiEn?.copy?.layerInsight;
    const hasMental = tried.includes('meditation') || tried.includes('therapie');
    const hasBiochem = tried.includes('supplements');
    const hasPhysical = tried.includes('sport');
    const layers = [];
    if (hasMental) layers.push(li?.mental || 'von oben (Kopf)');
    if (hasBiochem) layers.push(li?.biochem || 'von innen (Biochemie)');
    if (hasPhysical) layers.push(li?.physical || 'mit Bewegung');
    if (layers.length === 0) layers.push(li?.none || 'punktuell');
    return layers.join(li?.joiner || ' + ');
  }

  function blurPoint2(q1) {
    return (
      { schlaf: 'HT7', unruhe: 'HT7', verspannung: 'GB21', erschoepfung: 'PC6', konzentration: 'LI4', angst: 'PC6' }[
        q1
      ] || 'GB21'
    );
  }

  const EASE_QUIZ_PRODUCT_ANCHOR_ID = 'ease-product-info-target';

  function easeQuizProductHandleFromPath(pathname) {
    const p = String(pathname || '').replace(/\/$/, '');
    const m = p.match(/\/products\/([^/]+)$/);
    return m ? m[1].toLowerCase() : '';
  }

  function easeQuizSameProductPageAsUrl(productUrlStr) {
    let dest;
    try {
      dest = new URL(productUrlStr, window.location.origin);
    } catch (e) {
      return false;
    }
    if (dest.origin !== window.location.origin) return false;
    const h1 = easeQuizProductHandleFromPath(window.location.pathname);
    const h2 = easeQuizProductHandleFromPath(dest.pathname);
    return Boolean(h1 && h2 && h1 === h2);
  }

  /** Gleiche Ziel-Logik wie Sticky-ATC / Hero (ease-sticky-atc-bar → easeScrollToTarget). */
  function easeQuizScrollToProductMainTarget() {
    const sticky = document.querySelector('ease-sticky-atc-bar');
    if (sticky && typeof sticky.easeScrollToTarget === 'function') {
      sticky.easeScrollToTarget(EASE_QUIZ_PRODUCT_ANCHOR_ID);
      return;
    }
    const anchorEl =
      document.getElementById(EASE_QUIZ_PRODUCT_ANCHOR_ID) ||
      document.querySelector(`[id^="${EASE_QUIZ_PRODUCT_ANCHOR_ID}"]`) ||
      document.querySelector('#ease-product-info-target') ||
      document.querySelector('product-info[data-section="main"]') ||
      document.querySelector('product-info[id^="MainProduct-"]');
    if (!anchorEl) return;

    const productInfo = anchorEl.closest?.('product-info') || anchorEl;
    const mediaTopEl =
      productInfo?.querySelector?.('media-gallery') ||
      productInfo?.querySelector?.('.product__media-wrapper') ||
      anchorEl;

    const prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      mediaTopEl.scrollIntoView({ block: 'start' });
      return;
    }

    const start = window.pageYOffset || document.documentElement.scrollTop || 0;
    const rect = mediaTopEl.getBoundingClientRect();
    const target = Math.max(0, start + rect.top - 100);
    const distance = target - start;
    if (Math.abs(distance) < 2) return;

    const duration = Math.min(1200, Math.max(700, Math.abs(distance) * 0.6));

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    const t0 = performance.now();
    function step(now) {
      const p = Math.min(1, (now - t0) / duration);
      const y = start + distance * easeInOutCubic(p);
      window.scrollTo(0, y);
      if (p < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  /* ── Dashboard tracking helpers (outside init, no dependency on cfg) ── */

  function generateSessionId() {
    return 'qs-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  const DEFAULT = {
    layoutMode: 'popup',
    delayMs: 45000,
    autoPopupEnabled: false,
    productUrl: '/products/ease-akupressurkette',
    quizWebhookUrl: '',
    dashboardUrl: '',
    dashboardProjectId: '',
    dashboardWebhookSecret: '',
    baseTags: 'newsletter, nervensystem-check',
    intro: {
      badge: 'Dauert nur 60 Sekunden',
      titleHtml: 'Wie gestresst ist dein<br>Nervensystem <em>wirklich?</em>',
      sub: 'Finde heraus, wo dein Körper Hilfe braucht – und welche Akupressurpunkte dir gezielt helfen können.',
      features: [
        { icon: 'clock', cls: 'ico-clock', text: '8 kurze Fragen – fertig in unter 60 Sekunden' },
        { icon: 'tap', cls: 'ico-tap', text: 'Nur Antippen – kein Tippen nötig' },
        { icon: 'lock', cls: 'ico-lock', text: 'Persönliche Akupressur-Empfehlung am Ende' },
      ],
      cta: 'Jetzt Nervensystem-Check starten →',
      trust: 'Bereits 10.000+ Checks durchgeführt',
    },
    q1: {
      step: 'Frage 1 von 8',
      title: 'Was beschreibt dich gerade am besten?',
      sub: 'Wähle das, was sich am stärksten anfühlt.',
      options: [
        { v: 'unruhe', score: 3, icon: 'swirl', line: 'Ständige innere Unruhe', sub: 'Gedankenkarussell, kann nicht abschalten' },
        { v: 'schlaf', score: 3, icon: 'moon', line: 'Schlafprobleme', sub: 'Einschlafen, Durchschlafen oder müde aufwachen' },
        { v: 'verspannung', score: 2, icon: 'neck', line: 'Nacken- & Kieferverspannungen', sub: 'Schultern hochgezogen, Zähne zusammengebissen' },
        { v: 'erschoepfung', score: 3, icon: 'fatigue', line: 'Erschöpfung & Antriebslosigkeit', sub: 'Müde trotz genug Schlaf, alles ist anstrengend' },
        {
          v: 'konzentration',
          score: 2,
          icon: 'focus',
          line: 'Konzentration & Reizüberflutung',
          sub: 'Kann nicht fokussieren, Kopf voll, viele Reize gleichzeitig',
        },
        {
          v: 'angst',
          score: 3,
          icon: 'heart',
          line: 'Angst & Anspannung',
          sub: 'Nervosität, Herzrasen, innerliche Beklommenheit',
        },
      ],
    },
    q2: {
      step: 'Frage 2 von 8',
      title: 'Wie gestresst fühlst du dich im Moment?',
      sub: 'Ganz ehrlich – es gibt keine falsche Antwort.',
      emojis: [
        { v: 1, icon: 'veryHappy', label: 'Kaum' },
        { v: 2, icon: 'calm', label: 'Etwas' },
        { v: 3, icon: 'neutral', label: 'Mittel' },
        { v: 4, icon: 'stressed', label: 'Stark' },
        { v: 5, icon: 'overwhelmed', label: 'Extrem' },
      ],
    },
    q3: {
      step: 'Frage 3 von 8',
      title: 'Wie lange geht das schon so?',
      sub: 'Seit wann fühlst du dich so belastet?',
      options: [
        { v: 'wochen', score: 1, icon: 'calendar', line: 'Seit ein paar Wochen' },
        { v: 'monate', score: 2, icon: 'calendarRange', line: 'Seit einigen Monaten' },
        { v: 'jahr', score: 3, icon: 'calendarRange', line: 'Seit über einem Jahr' },
        { v: 'immer', score: 4, icon: 'infinity', line: 'Schon so lange ich mich erinnern kann' },
      ],
    },
    q4new: {
      step: 'Frage 4 von 8',
      title: 'Wann fühlst du das am stärksten?',
      sub: 'So können wir dir den besten Anwendungs-Zeitpunkt empfehlen.',
      options: [
        { v: 'morgen', icon: 'energy', line: 'Morgens beim Aufwachen', sub: 'schwer in den Tag zu kommen' },
        { v: 'job', icon: 'calendar', line: 'Tagsüber / unter Druck', sub: 'im Job, bei Stress-Spitzen' },
        { v: 'abend', icon: 'moon', line: 'Abends / vor dem Einschlafen', sub: 'kann nicht abschalten' },
        { v: 'nacht', icon: 'moon', line: 'Nachts', sub: 'wachst auf, kommst nicht zurück' },
        { v: 'termin', icon: 'clock', line: 'Vor wichtigen Terminen', sub: 'Anspannung, Nervosität' },
      ],
    },
    q4: {
      step: 'Frage 5 von 8',
      title: 'Merkst du das auch in deinem Körper?',
      sub: 'Wähle alles, was auf dich zutrifft.',
      next: 'Weiter →',
      options: [
        { v: 'kopf', score: 2, icon: 'head', line: 'Kopfschmerzen oder Kopfdruck' },
        { v: 'nacken', score: 2, icon: 'shoulder', line: 'Nacken & Schultern verspannt' },
        { v: 'kiefer', score: 2, icon: 'jaw', line: 'Kiefer angespannt oder Zähne knirschen' },
        { v: 'bauch', score: 1, icon: 'gut', line: 'Magenprobleme oder Verdauung' },
        { v: 'nichts', score: 0, icon: 'checkCircle', line: 'Eher weniger körperliche Symptome' },
      ],
    },
    q5: {
      step: 'Frage 6 von 8',
      title: 'Was hast du bisher dagegen probiert?',
      sub: 'Vieles davon hilft – aber oft nur an der Oberfläche.',
      next: 'Weiter →',
      options: [
        { v: 'meditation', score: 1, icon: 'meditate', line: 'Meditation oder Atemübungen' },
        { v: 'sport', score: 1, icon: 'run', line: 'Sport oder Yoga' },
        { v: 'supplements', score: 1, icon: 'pill', line: 'Supplements oder Tee' },
        { v: 'therapie', score: 1, icon: 'user', line: 'Therapie oder Coaching' },
        { v: 'nichts', score: 1, icon: 'checkCircle', line: 'Noch nichts Konkretes' },
      ],
    },
    q6: {
      step: 'Frage 7 von 8',
      title: 'Beeinflusst es deinen Alltag?',
      sub: 'Arbeit, Beziehungen, Energie – wie sehr schränkt es dich ein?',
      options: [
        { v: 'wenig', score: 1, icon: 'spark', line: 'Etwas, aber ich komme klar' },
        { v: 'mittel', score: 2, icon: 'warning', line: 'Ja, es nervt mich wirklich', sub: 'Ich bin nicht die Person, die ich sein könnte' },
        { v: 'stark', score: 3, icon: 'heartBreak', line: 'Stark – es zieht mich runter', sub: 'Job, Beziehung oder Gesundheit leiden' },
        { v: 'extrem', score: 4, icon: 'overwhelmed', line: 'Sehr stark – ich bin am Limit', sub: 'Ich brauche dringend etwas, das hilft' },
      ],
    },
    q7: {
      step: 'Frage 8 von 8 - Letzte Frage!',
      title: 'Was wünschst du dir am meisten?',
      sub: 'Wenn eines davon sich ab morgen ändern würde – was wäre es?',
      options: [
        { v: 'ruhe', icon: 'zen', line: 'Endlich innere Ruhe finden', sub: 'Gedankenkarussell stoppen, loslassen können' },
        { v: 'schlaf', icon: 'moon', line: 'Richtig gut schlafen', sub: 'Einschlafen, durchschlafen, erholt aufwachen' },
        { v: 'schmerz', icon: 'muscle', line: 'Verspannungen lösen', sub: 'Nacken, Kiefer, Schultern endlich locker' },
        { v: 'energie', icon: 'energy', line: 'Mehr Energie & Leichtigkeit', sub: 'Wieder Kraft für die Dinge, die mir wichtig sind' },
      ],
    },
    loading: {
      title: 'Dein Stress-Profil wird erstellt...',
      sub: 'Wir analysieren deine Antworten und stellen persönliche Empfehlungen zusammen.',
      steps: [
        'Stress-Level berechnen',
        'Symptom-Muster erkennen',
        'Akupressurpunkte zuordnen',
        'Persönliche Empfehlung erstellen',
      ],
    },
    email: {
      title: 'Dein Profil ist fertig!',
      sub: 'Trag deine E-Mail ein und erhalte sofort deine persönlichen Akupressurpunkt-Empfehlungen.',
      placeholder: 'Deine E-Mail-Adresse',
      submit: 'Meine Empfehlung anzeigen →',
      trust: 'Kein Spam. Jederzeit abmeldbar.',
      bonusHint: 'Zusätzlich wartet eine kleine Überraschung zu deinem Ergebnis auf dich.',
    },
    result: {
      pointsTitle: 'Deine empfohlenen Akupressurpunkte',
      ctaHtml:
        '<strong>EASE macht diese Punkte alltagstauglich.</strong><br>Eine elegante Kette mit integriertem Präzisions-Stift – stimuliert genau die Punkte, die dein Nervensystem braucht.',
      ctaBtn: 'Mein EASE-Angebot anzeigen →',
      bonusHint: 'Als kleines Extra zu deinem Ergebnis: Spare jetzt 20 EUR',
      bonusCode: 'TAKEITEASE20',
    },
    empathyMessages: {
      unruhe:
        'Das Gefühl, nicht abschalten zu können, kennen mehr Menschen als du denkst. Du bist damit nicht allein.',
      schlaf: 'Schlecht schlafen ist so zermürbend – vor allem, wenn man alles richtig macht und es trotzdem nicht klappt.',
      verspannung: 'Wenn der Körper die Anspannung trägt, die der Kopf nicht loslässt – das ist wirklich belastend.',
      erschoepfung: 'Müde sein trotz Schlaf – das ist eines der häufigsten Zeichen, dass dein Nervensystem überlastet ist.',
      konzentration:
        'Wenn der Kopf voll ist, bleibt kein Platz für Fokus. Das ist kein Disziplinproblem – das ist Überstimulierung deines Nervensystems.',
      angst: 'Angst und Anspannung sind echte Körpersignale. Du bist nicht „zu empfindlich" – du reagierst auf Überlastung.',
    },
    durationEmpathy: {
      wochen: 'Du bist früh dran. Lass uns präzise schauen, wann es bei dir kippt.',
      monate: 'Über Monate hinweg hat sich das verfestigt – jetzt ist der Punkt, an dem viele aufhören hinzuschauen.',
      jahr: 'Über ein Jahr ist viel — das hat sich tief verankert. Lass uns präzise schauen, wann es bei dir kippt.',
      immer: 'So lange du dich erinnern kannst — das ist Teil deines Grundtonus geworden. Auch das kann sich ändern.',
    },
    triggerEmpathy: {
      morgen: 'Wenn der Tag schon angespannt beginnt, hat dein NS nachts nicht abgeschaltet — das spürt der Körper.',
      job: 'Unter Druck zeigt sich, was sich verfestigt hat. Schauen wir, wo es bei dir tagsüber spürbar wird.',
      abend: 'Wenn nachts der Schlaf nicht hält, trägt der Körper tagsüber meist die Quittung.',
      nacht: 'Nächtliches Aufwachen ist eines der häufigsten — und am wenigsten verstandenen — Stress-Muster.',
      termin: 'Vor wichtigen Terminen verstärkt sich die Anspannung — der Körper merkt das oft als Erstes.',
    },
    stressEmpathy: {
      1: 'Gut, dass du präventiv dranbleibst.',
      2: 'Das ist ein guter Zeitpunkt, etwas für dich zu tun.',
      3: 'Das kennen viele – und es gibt einen Weg raus.',
      4: 'Das klingt wirklich belastend. Gut, dass du hier bist.',
      5: 'Das ist viel. Du verdienst Unterstützung – und du bist gerade auf dem richtigen Weg.',
    },
    alltagEmpathy: {
      wenig: 'Gut, dass du früh dranbleibst – Prävention ist immer leichter als Reparatur.',
      mittel: 'Das ehrlich zu sagen ist schon der erste Schritt. Dein Nervensystem braucht Unterstützung.',
      stark: 'Das ist wirklich viel. Du verdienst es, dich wieder wie du selbst zu fühlen.',
      extrem: 'Dass du hier bist und aktiv nach Lösungen suchst, zeigt echte Stärke. Wir schauen jetzt, was dir helfen kann.',
    },
    pointsDB: {
      kg17: {
        name: 'KG17 - Meer der Ruhe',
        icon: 'brain',
        location: 'Mitte des Brustbeins',
        desc: 'Der wichtigste Punkt bei innerer Unruhe und Stress. Beruhigt das Nervensystem und fördert tiefes Durchatmen.',
      },
      ht7: {
        name: 'HT7 - Tor der Seele',
        icon: 'zen',
        location: 'Innenseite des Handgelenks',
        desc: 'Ideal vor dem Einschlafen. Beruhigt den Geist und hilft beim Loslassen von Gedankenkreisen.',
      },
      gb21: {
        name: 'GB21 - Schulterbrunnen',
        icon: 'muscle',
        location: 'Mitte der Schulter',
        desc: 'Der Punkt bei Nacken- und Schulterverspannungen. Löst Anspannung, die sich über den Tag aufbaut.',
      },
      gb20: {
        name: 'GB20 - Windteich',
        icon: 'leaf',
        location: 'Schädelansatz am Nacken',
        desc: 'Hilft bei Kopfdruck, Nackenverspannungen und dem Gefühl, einen schweren Kopf zu haben.',
      },
      li4: {
        name: 'LI4 - Vereintes Tal',
        icon: 'hand',
        location: 'Zwischen Daumen und Zeigefinger',
        desc: 'Der bekannteste Akupressurpunkt überhaupt. Hilft bei Kopfschmerzen, Anspannung und fördert die Konzentration.',
      },
      si3: {
        name: 'SI3 - Hinterer Strom',
        icon: 'wave',
        location: 'Handkante, kleiner Finger',
        desc: 'Sehr wirksam bei Kiefer- und Nackenverspannungen. Besonders bei Stresszeichen wie Zähnepressen.',
      },
      pc6: {
        name: 'PC6 - Inneres Tor',
        icon: 'heart',
        location: 'Innenseite des Unterarms',
        desc: 'Beruhigt Übelkeit, Herzrasen und innere Aufregung. Besonders hilfreich bei stressbedingtem Unwohlsein.',
      },
    },
  };

  function deepMerge(a, b) {
    if (!b) return a;
    const out = Array.isArray(a) ? [...a] : { ...a };
    for (const k of Object.keys(b)) {
      if (b[k] && typeof b[k] === 'object' && !Array.isArray(b[k]) && typeof a[k] === 'object' && !Array.isArray(a[k])) {
        out[k] = deepMerge(a[k], b[k]);
      } else if (b[k] !== '' && b[k] != null) {
        out[k] = b[k];
      }
    }
    return out;
  }

  function deepMergeInto(target, source) {
    if (!source || !target) return target;
    const merged = deepMerge(target, source);
    if (Array.isArray(merged)) return merged;
    Object.keys(merged).forEach((k) => {
      target[k] = merged[k];
    });
    return target;
  }

  function isLocaleEn(raw) {
    const iso =
      (raw && raw.localeIso) ||
      (typeof document !== 'undefined' && document.documentElement && document.documentElement.lang) ||
      '';
    return String(iso).toLowerCase().startsWith('en');
  }

  let quizUiEn = null;

  function quizFill(template, vars) {
    if (!template) return '';
    const v = vars || {};
    return String(template).replace(/\{(\w+)\}/g, (_, k) => (v[k] != null ? String(v[k]) : ''));
  }

  function quizCopy(path, fallback, vars) {
    if (!quizUiEn?.copy) return quizFill(fallback, vars);
    const keys = path.split('.');
    let node = quizUiEn.copy;
    for (const k of keys) {
      if (node == null) return quizFill(fallback, vars);
      node = node[k];
    }
    if (typeof node !== 'string') return quizFill(fallback, vars);
    return quizFill(node, vars);
  }

  function applyQuizEnglishPack(raw) {
    const pack = typeof window !== 'undefined' && window.EASE_QUIZ_EN;
    if (!isLocaleEn(raw) || !pack) return;
    if (pack.default) deepMergeInto(DEFAULT, pack.default);
    if (pack.einblick1) deepMergeInto(EINBLICK1_LIBRARY, pack.einblick1);
    if (pack.einblick2) deepMergeInto(EINBLICK2_LIBRARY, pack.einblick2);
    if (pack.timeBoxTexts) Object.assign(TIME_BOX_TEXTS, pack.timeBoxTexts);
    quizUiEn = { ...(pack.ui || {}), copy: pack.copy || null };
  }

  function applyQuizStaticUi(root) {
    const u = quizUiEn;
    if (!u || !root) return;
    const setText = (sel, text) => {
      if (!text) return;
      const el = root.querySelector(sel);
      if (el) el.textContent = text;
    };
    const setHtml = (sel, html) => {
      if (!html) return;
      const el = root.querySelector(sel);
      if (el) el.innerHTML = html;
    };
    setText('#ease-quiz-screenEinblick1 .ease-q-step', u.einblick1Step);
    setText('[data-einblick1-badge]', u.einblick1Badge);
    setText('[data-einblick1-source]', u.einblick1Source);
    setText('[data-einblick1-next]', u.einblick1Next);
    setText('#ease-quiz-screenEinblick2 .ease-q-step', u.einblick2Step);
    setText('#ease-quiz-screenEinblick2 .ease-quiz-fact-badge', u.einblick2Badge);
    setText('[data-einblick2-source]', u.einblick2Source);
    setText('[data-einblick2-next]', u.einblick2Next);
    setText('[data-loading-almost] .ease-quiz-loading-almost-title', u.loadingAlmostTitle);
    setText('[data-loading-almost] .ease-quiz-loading-almost-sub', u.loadingAlmostSub);
    setText('[data-result-recap] .ease-quiz-recap-eyebrow', u.recapEyebrow);
    setText('[data-result-time-title]', u.timeBoxTitle);
    const safety = root.querySelector('[data-result-safety]');
    if (safety && u.safetyNote) safety.textContent = u.safetyNote;
    setText('.ease-quiz-offer-eyebrow', u.offerEyebrow);
    setHtml('.ease-quiz-offer-headline', u.offerHeadline);
    setText('.ease-quiz-qb-head', u.offerBridgeTitle);
    setText('.ease-quiz-compare-title', u.compareTitle);
    const crs = root.querySelectorAll('.ease-quiz-cr');
    if (crs[0] && u.compareTherapy) {
      const spans = crs[0].querySelectorAll('span');
      if (spans[0]) spans[0].textContent = u.compareTherapy;
      if (spans[1]) spans[1].textContent = u.compareTherapyPrice;
    }
    if (crs[1] && u.compareApp) {
      const spans = crs[1].querySelectorAll('span');
      if (spans[0]) spans[0].textContent = u.compareApp;
      if (spans[1]) spans[1].textContent = u.compareAppPrice;
    }
    if (crs[2] && u.compareMassage) {
      const spans = crs[2].querySelectorAll('span');
      if (spans[0]) spans[0].textContent = u.compareMassage;
      if (spans[1]) spans[1].textContent = u.compareMassagePrice;
    }
    if (crs[3] && u.compareMat) {
      const spans = crs[3].querySelectorAll('span');
      if (spans[0]) spans[0].textContent = u.compareMat;
      if (spans[1]) spans[1].textContent = u.compareMatPrice;
    }
    if (crs[4] && u.compareEase) {
      const spans = crs[4].querySelectorAll('span');
      if (spans[0]) spans[0].textContent = u.compareEase;
    }
    setText('.ease-quiz-cb-hint', u.offerCodeHint);
    setText('.ease-quiz-cpu', u.offerCostPerUse);
    const offerCta = root.querySelector('[data-offer-cta]');
    if (offerCta && u.offerCtaBig) offerCta.textContent = u.offerCtaBig;
    const trustSpans = root.querySelectorAll('.ease-quiz-trust-row > span');
    if (trustSpans[0] && u.offerTrustRow1) trustSpans[0].innerHTML = u.offerTrustRow1;
    if (trustSpans[1] && u.offerTrustRow2) trustSpans[1].innerHTML = u.offerTrustRow2;
    if (trustSpans[2] && u.offerTrustRow3) trustSpans[2].innerHTML = u.offerTrustRow3;
    setText('.ease-quiz-vs-title', u.packageTitle);
    const vsItems = root.querySelectorAll('.ease-quiz-vs-item');
    const vsTexts = [u.packageChain, u.packagePen, u.packageUsb, u.offerVsDesigned, u.offerVsShipping, u.offerVsGuarantee, u.offerVsWarranty];
    vsItems.forEach((item, i) => {
      if (!vsTexts[i]) return;
      const ck = item.querySelector('.ease-quiz-ck');
      item.textContent = '';
      if (ck) item.appendChild(ck);
      item.append(' ' + vsTexts[i]);
    });
    const psRows = root.querySelectorAll('.ease-quiz-ps-row span:first-child');
    if (psRows[0] && u.offerUvp) psRows[0].textContent = u.offerUvp;
    if (psRows[1] && u.offerToday) psRows[1].textContent = u.offerToday;
  }

  const state = {
    score: 0,
    answers: {},
    multiSelections: {},
    stressLevel: 0,
    sessionId: '',
  };

  function getRecommendedPoints(cfg) {
    const pts = [];
    const a = state.answers;
    const ms = state.multiSelections;
    pts.push('kg17');
    if (a[1] === 'unruhe' || a[7] === 'ruhe') pts.push('ht7');
    if (a[1] === 'schlaf' || a[7] === 'schlaf') pts.push('ht7');
    if (a[1] === 'verspannung' || a[7] === 'schmerz') pts.push('gb21');
    if (a[1] === 'erschoepfung') pts.push('pc6');
    if (a[1] === 'konzentration') pts.push('li4');
    if (a[1] === 'konzentration') pts.push('ht7');
    if (a[1] === 'angst') pts.push('ht7');
    if (a[1] === 'angst') pts.push('pc6');
    if (ms[4]) {
      if (ms[4].includes('kopf')) pts.push('li4');
      if (ms[4].includes('nacken')) pts.push('gb20');
      if (ms[4].includes('kiefer')) pts.push('si3');
      if (ms[4].includes('bauch')) pts.push('pc6');
    }
    if (a[7] === 'energie') pts.push('li4');
    return [...new Set(pts)].slice(0, 3);
  }

  function init(root) {
    const sid = root.dataset.sectionId || '';
    const fromWin =
      typeof window !== 'undefined' && window.__easeQuizCfgs && window.__easeQuizCfgs[sid]
        ? window.__easeQuizCfgs[sid]
        : null;
    const raw =
      fromWin && typeof fromWin === 'object'
        ? fromWin
        : root.dataset.config
          ? JSON.parse(root.dataset.config)
          : {};
    applyQuizEnglishPack(raw);
    let cfg = deepMerge(DEFAULT, raw);
    if (isLocaleEn(raw) && window.EASE_QUIZ_EN && window.EASE_QUIZ_EN.default) {
      cfg = deepMerge(cfg, window.EASE_QUIZ_EN.default);
    }
    const layoutMode = cfg.layoutMode === 'page' || root.dataset.quizLayout === 'page' ? 'page' : 'popup';
    const isPageLayout = layoutMode === 'page';
    const designMode = raw.designMode === true || raw.designMode === 'true';
    const previewStep = raw.previewStep || 'intro';
    /* Live-Shop: Popup erst nach delayMs (Standard 45s aus Section). Theme-Editor: kein Auto-Popup. */
    const delayMs = Number(cfg.delayMs) || 45000;
    const sessionKey = 'ease-nervensystem-quiz:auto-' + (raw.sectionId || 'default');

    if (isPageLayout) root.classList.add('ease-nervensystem-quiz--page-layout');

    const modal = root.querySelector('[data-quiz-modal]');
    const shell = root.querySelector('[data-quiz-shell]');
    const banner = root.querySelector('[data-quiz-banner]');
    const form = root.querySelector('.ease-quiz-customer-form');
    const tagsInput = form?.querySelector('[data-quiz-tags]');
    const emailInput = form?.querySelector('[data-quiz-email]');
    const editorBtn = root.querySelector('[data-ease-quiz-editor-open]');
    applyQuizStaticUi(root);
    if (editorBtn && quizUiEn && quizUiEn.editorOpen) editorBtn.textContent = quizUiEn.editorOpen;

    /* ── Dashboard tracking (defined inside init so it can access cfg & buildTags) ── */

    function trackDashboardStep(stepName) {
      var url = String(cfg.dashboardUrl || '').trim();
      var projectId = String(cfg.dashboardProjectId || '').trim();
      var secret = String(cfg.dashboardWebhookSecret || '').trim();
      if (!url || !projectId || !secret || !state.sessionId) return;
      var endpoint = url.replace(/\/$/, '') + '/api/webhooks/quiz';
      fetch(endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-webhook-secret': secret,
          'x-project-id': projectId,
        },
        body: JSON.stringify({ session_id: state.sessionId, step: stepName }),
        keepalive: true,
        mode: 'cors',
      }).catch(function () {});
    }

    function sendDashboardSubmission(email) {
      var url = String(cfg.dashboardUrl || '').trim();
      var projectId = String(cfg.dashboardProjectId || '').trim();
      var secret = String(cfg.dashboardWebhookSecret || '').trim();
      if (!url || !projectId || !secret) return;
      var endpoint = url.replace(/\/$/, '') + '/api/webhooks/quiz';
      var marketing = form ? form.querySelector('[data-quiz-marketing]') : null;
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-webhook-secret': secret,
          'x-project-id': projectId,
        },
        body: JSON.stringify({
          email: email || '',
          accepts_marketing: marketing ? marketing.checked : true,
          q1: state.answers[1] || null,
          q2: typeof state.answers[2] === 'number' ? state.answers[2] : parseInt(state.answers[2]) || null,
          q3: state.answers[3] || null,
          q4: state.multiSelections[4] || [],
          q5: state.multiSelections[5] || [],
          q6: state.answers[6] || null,
          q7: state.answers[7] || null,
          stress_score: state.stressLevel,
          tags: buildTags().split(', '),
        }),
        keepalive: true,
        mode: 'cors',
      }).catch(function () {});
    }

    /* ── End dashboard tracking ── */

    function showScreen(id) {
      root.querySelectorAll('.ease-quiz-screen').forEach((s) => s.classList.remove('ease-quiz-screen--active'));
      const el = root.querySelector('#' + id);
      if (el) el.classList.add('ease-quiz-screen--active');
    }

    function updateProgress(step) {
      const bar = root.querySelector('[data-quiz-progress]');
      if (bar) bar.style.width = (step / 10) * 100 + '%';
    }

    function renderLoadingStepMarkup(text, index) {
      return `<div class="ease-quiz-loading-step" data-ls="${index + 1}"><span class="ease-quiz-ls-icon" aria-hidden="true">${index + 1}</span><span class="ease-quiz-loading-step-text">${text}</span></div>`;
    }

    function buildLoadingSteps() {
      const a = state.answers;
      const ms = state.multiSelections;
      const trigger = a.trigger;
      const q1 = a[1];
      const q6tried = ms[5] || [];
      const profileLabels = {
        schlaf: 'Schlaf-Profil',
        unruhe: 'Stress-Profil',
        verspannung: 'Verspannungs-Profil',
        erschoepfung: 'Erschöpfungs-Profil',
        konzentration: 'Reizüberflutungs-Profil',
        angst: 'Anspannungs-Profil',
      };
      const patternLabels = {
        morgen: 'morgendliches Muster',
        job: 'Arbeits-Stress-Muster',
        abend: 'abendliches Muster',
        nacht: 'nächtliches Muster',
        termin: 'Termin-Anspannungs-Muster',
      };
      const timeLabels = {
        morgen: 'morgendliche Anwendung',
        job: 'Tages-Anwendung',
        abend: 'abendliche Anwendung',
        nacht: 'nächtliche Anwendung',
        termin: 'Anwendung vor Terminen',
      };

      const profileLabel = quizCopy(`profileLabels.${q1}`, profileLabels[q1] || 'Stress-Profil');
      const patternLabel = quizCopy(`patternLabels.${trigger}`, patternLabels[trigger] || 'dein Muster');
      const triedFiltered = q6tried.filter((t) => t !== 'nichts');
      const triedLabel =
        triedFiltered.length > 0
          ? triedFiltered.map((t) => EINBLICK2_LIBRARY.tried_echo[t]).filter(Boolean).join(' + ')
          : quizCopy('freshStart', 'deinen frischen Start');
      const timeLabel = quizCopy(`timeLabels.${trigger}`, timeLabels[trigger] || 'Anwendung');
      const capPattern = patternLabel.charAt(0).toUpperCase() + patternLabel.slice(1);

      return [
        quizCopy('loadingSteps.analyze', `Dein <em>${profileLabel}</em> wird analysiert`, { profile: profileLabel }),
        quizCopy('loadingSteps.mapPattern', `<em>${capPattern}</em> zuordnen`, { pattern: capPattern }),
        quizCopy('loadingSteps.factorTried', `<em>${triedLabel}</em> in Empfehlung einrechnen`, { tried: triedLabel }),
        quizCopy('loadingSteps.pickPoints', `3 Punkte für <em>${timeLabel}</em> auswählen`, { time: timeLabel }),
      ];
    }

    function renderEinblick1() {
      const a = state.answers;
      const q1 = a[1];
      const q3 = a[3];
      const trigger = a.trigger;

      const q1Echo =
        EINBLICK1_LIBRARY.q1_echo[q1] || (quizUiEn && quizUiEn.stressSymptomsDefault) || 'Stress-Symptome';
      const q3Echo = EINBLICK1_LIBRARY.q3_echo[q3] || (quizUiEn && quizUiEn.forAWhile) || 'seit einiger Zeit';
      const triggerLine = EINBLICK1_LIBRARY.trigger_line[trigger] || '';
      const stat = EINBLICK1_LIBRARY.stat[q1] || EINBLICK1_LIBRARY.stat.default;
      const insight = EINBLICK1_LIBRARY.insight[q1] || EINBLICK1_LIBRARY.insight.default;
      const reframe = EINBLICK1_LIBRARY.reframe[q1] || EINBLICK1_LIBRARY.reframe.default;

      const headline = quizCopy(
        'einblick1Headline',
        `Du sagst: <em>${q1Echo} ${q3Echo}</em>${triggerLine ? ` – und ${triggerLine}` : ''}.`,
        { q1: q1Echo, q3: q3Echo, suffix: triggerLine ? quizCopy('einblick1TriggerSuffix', ` – und ${triggerLine}`, { trigger: triggerLine }) : '' }
      );

      const titleEl = root.querySelector('[data-einblick1-title]');
      const statNum = root.querySelector('[data-einblick1-statnum]');
      const statLabel = root.querySelector('[data-einblick1-statlabel]');
      const bodyEl = root.querySelector('[data-einblick1-body]');
      const reframeEl = root.querySelector('[data-einblick1-reframe]');
      if (titleEl) titleEl.innerHTML = headline;
      if (statNum) statNum.textContent = stat.num;
      if (statLabel) statLabel.innerHTML = stat.label;
      if (bodyEl) bodyEl.innerHTML = insight;
      if (reframeEl) reframeEl.innerHTML = reframe;
    }

    function renderEinblick2() {
      const a = state.answers;
      const ms = state.multiSelections;
      const q5body = ms[4] || [];
      const q6tried = ms[5] || [];
      const q7impact = a[6];
      const trigger = a.trigger;

      const triedEcho = formatList(
        q6tried.map((t) => EINBLICK2_LIBRARY.tried_echo[t]).filter(Boolean)
      );
      const bodyEcho = formatBodyAreas(q5body);
      const layerInsight = buildLayerInsight(q6tried);
      const toneClose = EINBLICK2_LIBRARY.tone_by_impact[q7impact] || '';
      const triggerBridge =
        trigger === 'nacht'
          ? quizCopy('einblick2TriggerBridgeNight', 'bei Menschen mit nächtlichem Aufwachen')
          : trigger === 'abend'
            ? quizCopy('einblick2TriggerBridgeEvening', 'bei abendlicher Anspannung')
            : quizCopy('einblick2TriggerBridgeDefault', 'bei körperlicher Anspannung');
      const triedCount = q6tried.filter((t) => t !== 'nichts').length;

      const headline = quizCopy(
        'einblick2Headline',
        `Du hast <em>${triedEcho}</em> probiert – und <em>${bodyEcho}</em> sind trotzdem angespannt.`,
        { tried: triedEcho, body: bodyEcho }
      );
      const stat = {
        num: quizCopy('einblick2StatNum', `${triedCount} Wege`, { count: String(triedCount) }),
        label: quizCopy('einblick2StatLabel', `die du bisher gegangen bist: <strong>${layerInsight}</strong>`, {
          layers: layerInsight,
        }),
      };
      const body = quizCopy(
        'einblick2Body',
        'Beides ist sinnvoll. Aber genau da, wo deine Anspannung sich festsetzt – am Vagusnerv und der Faszien-Linie über Brust, Nacken und Kiefer – kommen diese Versuche nicht direkt an. Das ist kein Zeichen, dass du etwas falsch machst. Es ist eine fehlende dritte Ebene: der körperliche Zugang.'
      );
      const reframe = quizCopy(
        'einblick2Reframe',
        `Akupressur am Punkt <strong>KG17</strong> (Mitte des Brustbeins, in der TCM seit 5.000 Jahren als „Meer der Ruhe" dokumentiert) aktiviert den Vagusnerv direkt über die Haut. Studien zeigen: ${triggerBridge} schaltet diese Stimulation den Parasympathikus messbar schneller ein als kognitive Techniken. ${toneClose}`,
        { triggerBridge, tone: toneClose }
      );

      const titleEl = root.querySelector('[data-einblick2-title]');
      const statNum = root.querySelector('[data-einblick2-statnum]');
      const statLabel = root.querySelector('[data-einblick2-statlabel]');
      const bodyEl = root.querySelector('[data-einblick2-body]');
      const reframeEl = root.querySelector('[data-einblick2-reframe]');
      if (titleEl) titleEl.innerHTML = headline;
      if (statNum) statNum.textContent = stat.num;
      if (statLabel) statLabel.innerHTML = stat.label;
      if (bodyEl) bodyEl.innerHTML = body;
      if (reframeEl) reframeEl.innerHTML = reframe;
    }

    function buildRecapText() {
      const a = state.answers;
      const ms = state.multiSelections;
      const q1Echo =
        EINBLICK1_LIBRARY.q1_echo[a[1]] || (quizUiEn && quizUiEn.stressSymptomsDefault) || 'Stress-Symptome';
      const q3Echo = EINBLICK1_LIBRARY.q3_echo[a[3]] || (quizUiEn && quizUiEn.forAWhile) || 'seit einiger Zeit';
      const trigger = a.trigger;
      const triggerText = EINBLICK1_LIBRARY.trigger_line[trigger] || '';
      const body = formatBodyAreas(ms[4] || []);
      const tried = (ms[5] || []).filter((t) => t !== 'nichts');
      const triedList = tried.map((t) => EINBLICK2_LIBRARY.tried_echo[t]).filter(Boolean).join(` ${quizUiEn?.and || 'und'} `);
      const triedText =
        tried.length > 0
          ? quizCopy('recapTriedWith', `Bisher hast du <b>${triedList}</b> probiert`, { list: triedList })
          : quizCopy('recapTriedNone', 'Bisher hast du noch nichts Konkretes probiert');
      const impactMap = {
        wenig: 'kommst aber klar',
        mittel: 'es nervt dich',
        stark: 'es zieht dich runter',
        extrem: 'du bist am Limit',
      };
      const wishMap = {
        ruhe: 'innere Ruhe finden',
        schlaf: 'richtig gut schlafen',
        schmerz: 'Verspannungen lösen',
        energie: 'mehr Energie',
      };
      const impactText = quizCopy(`recapImpact.${a[6]}`, impactMap[a[6]] || '');
      const wishText = quizCopy(`recapWish.${a[7]}`, wishMap[a[7]] || 'Erleichterung');
      const triggerPart = triggerText
        ? quizCopy('recapTriggerPart', `am stärksten ${triggerText}, `, { trigger: triggerText })
        : '';

      return quizCopy(
        'recapTemplate',
        `<b>${q1Echo}</b> ${q3Echo}, ${triggerPart}und es zeigt sich auch in <b>${body}</b>. ${triedText}, und ${impactText}. Dein Wunsch: <b>${wishText}</b>.`,
        { q1: q1Echo, q3: q3Echo, triggerPart, body, triedPart: triedText, impactPart: impactText, wish: wishText }
      );
    }

    function buildSocialProof(q1) {
      const map = {
        schlaf:
          '<strong style="color:#2d5a3f">78 % der Nutzerinnen mit deinem Profil</strong> berichten, dass sie nach 2–3 Wochen abends schneller abschalten können.',
        unruhe:
          '<strong style="color:#2d5a3f">71 % berichten</strong>, dass das Gedankenkreisen nach wenigen Wochen seltener wird.',
        verspannung:
          '<strong style="color:#2d5a3f">82 % spüren</strong> in den ersten Wochen Erleichterung im Nacken- und Schulterbereich.',
        erschoepfung:
          '<strong style="color:#2d5a3f">68 % berichten</strong>, sich morgens erholter zu fühlen.',
        konzentration:
          '<strong style="color:#2d5a3f">74 % berichten</strong>, klarer denken zu können nach kurzen Akupressur-Pausen.',
        angst:
          '<strong style="color:#2d5a3f">76 % berichten</strong>, dass akute Anspannung sich schneller löst.',
      };
      const fallback =
        map[q1] ||
        '<strong style="color:#2d5a3f">Viele Nutzerinnen und Nutzer berichten</strong>, dass sich erste Effekte nach wenigen Wochen zeigen.';
      return quizCopy(`socialProof.${q1}`, fallback) || quizCopy('socialProof.default', fallback);
    }

    function renderOffer(cfg) {
      const a = state.answers;
      const ms = state.multiSelections;
      const q1 = a[1];
      const tried = (ms[5] || []).filter((t) => t !== 'nichts');
      const trigger = a.trigger;

      const offerProfiles = {
        schlaf: 'Schlaf-Profil',
        unruhe: 'Unruhe-Profil',
        verspannung: 'Verspannungs-Profil',
        erschoepfung: 'Erschöpfungs-Profil',
        konzentration: 'Reizüberflutungs-Profil',
        angst: 'Anspannungs-Profil',
      };
      const explainDe = {
        schlaf: 'die <b>Kette</b> liegt automatisch auf KG17 – stimuliert deinen Vagusnerv abends im Bett, ohne dass du aktiv etwas tun musst. Der <b>Stift</b> erreicht HT7 am Handgelenk für die Einschlaf-Routine.',
        unruhe:
          'die <b>Kette</b> liegt automatisch auf KG17 – dem Punkt, der Gedankenkreisen am direktesten unterbricht. Der <b>Stift</b> mit Vibration aktiviert HT7 für sofortige Beruhigung.',
        verspannung:
          'der <b>Präzisions-Stift</b> erreicht GB21 (Schulterbrunnen) und GB20 (Nackenansatz) – beide Punkte, die mit Fingern kaum richtig erreichbar sind. Die <b>Kette</b> arbeitet parallel am KG17.',
        erschoepfung:
          'die <b>Kette</b> liegt automatisch auf KG17 – aktiviert tagsüber den Vagusnerv für echte Erholung. Der <b>Stift</b> mit Energie-Modus stimuliert PC6 und LI4.',
        konzentration:
          'der <b>Stift</b> mit 3 Vibrationsmodi erreicht LI4 (Konzentrations-Punkt) und HT7. Die <b>Kette</b> dient als Reminder + Reizpause-Punkt.',
        angst:
          'die <b>Kette</b> liegt automatisch auf KG17 – der akuteste Punkt bei aufkommender Anspannung. Der <b>Stift</b> erreicht PC6 (innerer Beruhigungs-Punkt) jederzeit unauffällig.',
      };

      const profileLabel = quizCopy(`offerProfileLabels.${q1}`, offerProfiles[q1] || 'Stress-Profil');
      const explain = quizCopy(`offerExplain.${q1}`, explainDe[q1] || explainDe.unruhe);
      const triedList = tried.map((t) => EINBLICK2_LIBRARY.tried_echo[t]).filter(Boolean).join(` ${quizUiEn?.and || 'und'} `);
      const triedText =
        tried.length > 0
          ? quizCopy('offerTriedWith', `Genau das, was <b>${triedList}</b> nicht leisten konnten.`, { list: triedList })
          : quizCopy('offerTriedNone', 'Ein körperlicher Zugang, der dort ansetzt, wo mentale Methoden nicht hinkommen.');

      const bridgeHtml = quizCopy(
        'offerBridge',
        `Für dein <b>${profileLabel}</b> ist EASE wie gemacht: ${explain} ${triedText}`,
        { profile: profileLabel, explain, tried: triedText }
      );

      const bridgeEl = root.querySelector('[data-offer-bridge-text]');
      if (bridgeEl) bridgeEl.innerHTML = bridgeHtml;

      const productPath = String(cfg.productUrl || DEFAULT.productUrl || '/products/ease-akupressurkette').split('?')[0];
      const params = new URLSearchParams({
        profile: q1 || '',
        trigger: trigger || '',
        score: String(state.stressLevel || 0),
      });
      const redirectPath = productPath + '#ease-product-info-target&' + params.toString();
      const discountUrl =
        '/discount/TAKEITEASE20?redirect=' + encodeURIComponent(redirectPath);

      const offerCta = root.querySelector('[data-offer-cta]');
      if (offerCta) offerCta.setAttribute('href', discountUrl);
    }

    function openModal(fromEditor) {
      if (designMode && previewStep === 'closed') {
        closeModal();
        return;
      }
      if (!state.sessionId) {
        state.sessionId = generateSessionId();
      }
      if (!isPageLayout) {
        shell?.removeAttribute('hidden');
        document.documentElement.classList.add('ease-quiz-modal-open');
      }
      if (fromEditor || designMode) {
        applyPreviewStep();
      } else {
        resetQuizFlow();
      }
    }
    root.__easeQuizOpen = function () {
      if (isPageLayout) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      root.dispatchEvent(new CustomEvent('ease-quiz:cancel-delay'));
      openModal(false);
    };

    function closeModal() {
      if (isPageLayout) return;
      shell?.setAttribute('hidden', '');
      document.documentElement.classList.remove('ease-quiz-modal-open');
    }

    function resetQuizFlow() {
      state.score = 0;
      state.answers = {};
      state.multiSelections = {};
      state.stressLevel = 0;
      state.sessionId = generateSessionId();
      root.querySelectorAll('.ease-quiz-option.selected, .ease-quiz-emoji.selected').forEach((b) => b.classList.remove('selected'));
      if (emailInput) emailInput.value = '';
      renderIntro();
      showScreen('ease-quiz-screenIntro');
      updateProgress(0);
      trackDashboardStep('intro');
    }

    function applyPreviewStep() {
      const map = {
        intro: 'ease-quiz-screenIntro',
        q1: 'ease-quiz-screenQ1',
        q2: 'ease-quiz-screenQ2',
        q3: 'ease-quiz-screenQ3',
        q4new: 'ease-quiz-screenQ4New',
        einblick1: 'ease-quiz-screenEinblick1',
        q4: 'ease-quiz-screenQ4',
        q5: 'ease-quiz-screenQ5',
        q6: 'ease-quiz-screenQ6',
        einblick2: 'ease-quiz-screenEinblick2',
        q7: 'ease-quiz-screenQ7',
        loading: 'ease-quiz-screenLoading',
        email: 'ease-quiz-screenEmail',
        result: 'ease-quiz-screenResult',
        offer: 'ease-quiz-screenOffer',
        closed: null,
      };
      const progressMap = {
        intro: 0,
        q1: 1,
        q2: 2,
        q3: 3,
        q4new: 4,
        einblick1: 4,
        q4: 5,
        q5: 6,
        q6: 7,
        einblick2: 7,
        q7: 8,
        loading: 9,
        email: 9,
        result: 9,
        offer: 10,
      };
      const id = map[previewStep];
      if (previewStep === 'closed') {
        closeModal();
        return;
      }
      if (id) {
        if (previewStep === 'result') {
          state.stressLevel = 55;
          state.answers = { 1: 'schlaf', 3: 'monate', trigger: 'abend', 6: 'mittel', 7: 'schlaf' };
          state.multiSelections = { 4: ['nacken'], 5: ['meditation'] };
          showResults(cfg);
        } else if (previewStep === 'offer') {
          state.stressLevel = 62;
          state.answers = { 1: 'schlaf', 3: 'monate', trigger: 'nacht', 6: 'stark', 7: 'schlaf' };
          state.multiSelections = { 4: ['kopf', 'nacken'], 5: ['meditation', 'supplements'] };
          renderOffer(cfg);
          showScreen(id);
        } else if (previewStep === 'email') {
          state.stressLevel = 62;
          showEmailGate(cfg);
        } else if (previewStep === 'einblick1') {
          state.answers = { 1: 'schlaf', 3: 'jahr', trigger: 'nacht' };
          renderEinblick1();
          showScreen(id);
        } else if (previewStep === 'einblick2') {
          state.answers = { 6: 'stark', trigger: 'nacht' };
          state.multiSelections = { 4: ['kopf'], 5: ['meditation', 'supplements'] };
          renderEinblick2();
          showScreen(id);
        } else {
          showScreen(id);
        }
        updateProgress(progressMap[previewStep] != null ? progressMap[previewStep] : 0);
      }
    }

    function renderIntro() {
      const n = cfg.intro;
      const badge = root.querySelector('[data-quiz-intro-badge]');
      const title = root.querySelector('[data-quiz-intro-title]');
      const sub = root.querySelector('[data-quiz-intro-sub]');
      const ul = root.querySelector('[data-quiz-intro-features]');
      const cta = root.querySelector('[data-quiz-intro-cta]');
      const trust = root.querySelector('[data-quiz-intro-trust]');
      if (badge) badge.textContent = n.badge;
      if (title) title.innerHTML = n.titleHtml;
      if (sub) sub.textContent = n.sub;
      if (cta) cta.textContent = n.cta;
      if (trust) trust.textContent = n.trust;
      if (ul && n.features) {
        ul.innerHTML = n.features
          .map(
            (f) =>
              `<li><span class="ease-quiz-ico ${f.cls}">${iconSvg(f.icon)}</span> ${f.text}</li>`
          )
          .join('');
      }
    }

    function bindQuestions() {
      renderQ('q1', cfg.q1, 'single', 1);
      renderQ('q2', cfg.q2, 'emoji', 2);
      renderQ('q3', cfg.q3, 'single', 3);
      renderQ('q4new', cfg.q4new, 'single', 'q4new');
      renderMulti('q4', cfg.q4, 4);
      renderMulti('q5', cfg.q5, 5);
      renderQ('q6', cfg.q6, 'single', 6);
      renderQ('q7', cfg.q7, 'single', 7);

      const labels = root.querySelectorAll('[data-q-step]');
      labels.forEach((el) => {
        const key = el.dataset.qStep;
        const block = cfg[key];
        if (block && block.step) el.textContent = block.step;
      });
      ['q1', 'q2', 'q3', 'q4new', 'q4', 'q5', 'q6', 'q7'].forEach((k) => {
        const block = cfg[k];
        const titleEl = root.querySelector(`[data-q-title="${k}"]`);
        const subEl = root.querySelector(`[data-q-sub="${k}"]`);
        if (titleEl && block.title) titleEl.textContent = block.title;
        if (subEl && block.sub) subEl.textContent = block.sub;
      });

      const lt = root.querySelector('[data-loading-title]');
      const ls = root.querySelector('[data-loading-sub]');
      if (lt) lt.textContent = cfg.loading.title;
      if (ls) ls.textContent = cfg.loading.sub;
      const steps = root.querySelector('[data-loading-steps]');
      if (steps && cfg.loading.steps) {
        steps.innerHTML = cfg.loading.steps.map((t, i) => renderLoadingStepMarkup(t, i)).join('');
      }

      const et = root.querySelector('[data-email-title]');
      const es = root.querySelector('[data-email-sub]');
      const ep = root.querySelector('[data-quiz-email]');
      const eb = root.querySelector('[data-email-submit]');
      const etr = root.querySelector('[data-email-trust]');
      const ebh = root.querySelector('[data-email-bonus]');
      if (et) et.textContent = cfg.email.title;
      if (es) es.textContent = cfg.email.sub;
      if (ep) ep.placeholder = cfg.email.placeholder;
      if (eb) eb.textContent = cfg.email.submit;
      if (etr) etr.textContent = cfg.email.trust;
      if (ebh) ebh.textContent = cfg.email.bonusHint || '';

      const pt = root.querySelector('[data-result-points-title]');
      if (pt) pt.innerHTML = cfg.result.pointsTitle;
      const ctaBox = root.querySelector('[data-result-cta-text]');
      if (ctaBox) ctaBox.innerHTML = cfg.result.ctaHtml || '';
      const ctaA = root.querySelector('[data-result-cta-link]');
      if (ctaA) {
        ctaA.textContent = cfg.result.ctaBtn;
        ctaA.href = cfg.productUrl || DEFAULT.productUrl;
      }
      const bonusWrap = root.querySelector('[data-result-bonus]');
      const bonusHint = root.querySelector('[data-result-bonus-hint]');
      const bonusCode = root.querySelector('[data-result-bonus-code]');
      if (bonusWrap && bonusHint && bonusCode) {
        const code = String((cfg.result && cfg.result.bonusCode) || '').trim();
        if (code) {
          bonusWrap.hidden = false;
          bonusHint.textContent = cfg.result.bonusHint || '';
          bonusCode.textContent = code;
        } else {
          bonusWrap.hidden = true;
        }
      }
    }

    function renderQ(key, block, type, qnum) {
      const wrap = root.querySelector(`[data-q-options="${key}"]`);
      if (!wrap || !block) return;
      if (type === 'single') {
        wrap.innerHTML = block.options
          .map(
            (o) => `
          <button type="button" class="ease-quiz-option ease-quiz-option-btn" data-q="${qnum}" data-val="${o.v}" data-score="${o.score != null ? o.score : 0}">
            <span class="ease-quiz-option-icon">${iconSvg(o.icon)}</span>
            <span class="ease-quiz-option-text">${o.line}${o.sub ? `<small>${o.sub}</small>` : ''}</span>
          </button>`
          )
          .join('');
        wrap.querySelectorAll('.ease-quiz-option-btn').forEach((btn) => {
          btn.addEventListener('click', () => answerSingle(qnum, btn.dataset.val, btn, cfg));
        });
      } else if (type === 'emoji') {
        wrap.innerHTML = block.emojis
          .map(
            (o) => `
          <button type="button" class="ease-quiz-emoji ease-quiz-emoji-btn" data-q="${qnum}" data-val="${o.v}">
            <span class="ease-quiz-emoji-btn-inner">
              <span class="ease-quiz-em">${iconSvg(o.icon || o.em)}</span>
              <span class="ease-quiz-em-label">${o.label}</span>
            </span>
          </button>`
          )
          .join('');
        wrap.querySelectorAll('.ease-quiz-emoji-btn').forEach((btn) => {
          btn.addEventListener('click', () => answerEmoji(qnum, Number(btn.dataset.val), btn, cfg));
        });
      }
    }

    function renderMulti(key, block, qnum) {
      const wrap = root.querySelector(`[data-q-options="${key}"]`);
      const nextBtn = root.querySelector(`[data-multi-next="${key}"]`);
      if (!wrap || !block) return;
      wrap.innerHTML = block.options
        .map(
          (o) => `
        <button type="button" class="ease-quiz-option ease-quiz-option-btn ease-quiz-multi" data-q="${qnum}" data-val="${o.v}" data-score="${o.score}">
          <span class="ease-quiz-option-icon">${iconSvg(o.icon)}</span>
          <span class="ease-quiz-option-text">${o.line}</span>
        </button>`
        )
        .join('');
      wrap.querySelectorAll('.ease-quiz-multi').forEach((btn) => {
        btn.addEventListener('click', () => toggleMulti(btn, btn.dataset.val, qnum, wrap, block));
      });
      if (nextBtn) nextBtn.textContent = block.next || quizCopy('weiter', 'Weiter →');
    }

    function answerSingle(q, val, btn, cfg) {
      const parent = btn.parentElement;
      parent.querySelectorAll('.ease-quiz-option-btn').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
      if (q === 'q4new') {
        state.answers.trigger = val;
      } else {
        state.answers[q] = val;
        state.score += parseInt(btn.dataset.score, 10) || 0;
      }

      setTimeout(() => {
        if (q === 1) {
          const emp = root.querySelector('[data-empathy-q2]');
          if (emp) emp.innerHTML = cfg.empathyMessages[val] || '';
          showScreen('ease-quiz-screenQ2');
          updateProgress(2);
          trackDashboardStep('q2');
        } else if (q === 3) {
          const emp = root.querySelector('[data-empathy-q4new]');
          if (emp) emp.innerHTML = (cfg.durationEmpathy && cfg.durationEmpathy[val]) || '';
          showScreen('ease-quiz-screenQ4New');
          updateProgress(4);
          trackDashboardStep('q4new');
        } else if (q === 'q4new') {
          const emp = root.querySelector('[data-empathy-q5]');
          if (emp) emp.innerHTML = (cfg.triggerEmpathy && cfg.triggerEmpathy[val]) || '';
          showScreen('ease-quiz-screenEinblick1');
          updateProgress(4);
          trackDashboardStep('einblick1');
          renderEinblick1();
        } else if (q === 6) {
          showScreen('ease-quiz-screenEinblick2');
          updateProgress(7);
          trackDashboardStep('einblick2');
          renderEinblick2();
        } else if (q === 7) {
          startLoading(cfg);
        }
      }, 350);
    }

    function answerEmoji(q, val, btn, cfg) {
      btn.parentElement.querySelectorAll('.ease-quiz-emoji-btn').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
      state.answers[q] = val;
      state.score += val;
      setTimeout(() => {
        const emp = root.querySelector('[data-empathy-q3]');
        if (emp) emp.innerHTML = cfg.stressEmpathy[val] || '';
        showScreen('ease-quiz-screenQ3');
        updateProgress(3);
        trackDashboardStep('q3');
      }, 400);
    }

    function toggleMulti(btn, val, q, wrap, block) {
      btn.classList.toggle('selected');
      if (!state.multiSelections[q]) state.multiSelections[q] = [];

      if (val === 'nichts') {
        if (btn.classList.contains('selected')) {
          wrap.querySelectorAll('.ease-quiz-option-btn').forEach((b) => {
            if (b !== btn) b.classList.remove('selected');
          });
          state.multiSelections[q] = ['nichts'];
        } else {
          state.multiSelections[q] = [];
        }
        return;
      }

      const noneBtn = wrap.querySelector('.ease-quiz-option-btn[data-val="nichts"]');
      if (noneBtn) noneBtn.classList.remove('selected');
      state.multiSelections[q] = state.multiSelections[q].filter((v) => v !== 'nichts');

      if (btn.classList.contains('selected')) {
        if (!state.multiSelections[q].includes(val)) state.multiSelections[q].push(val);
      } else {
        state.multiSelections[q] = state.multiSelections[q].filter((v) => v !== val);
      }
    }

    function submitMulti(q, cfg) {
      const sels = state.multiSelections[q] || [];
      if (q === 4) {
        sels.forEach((s) => {
          if (s !== 'nichts') state.score += 2;
        });
        let empText = '';
        if (sels.includes('kopf') || sels.includes('nacken') || sels.includes('kiefer')) {
          empText = quizCopy(
            'multiEmpathyBody',
            'Wenn sich Stress in deinem Körper festsetzt, reichen mentale Techniken oft nicht aus. Dein Nervensystem braucht einen anderen Zugang.'
          );
        } else if (sels.includes('bauch')) {
          empText = quizCopy(
            'multiEmpathyBelly',
            'Dein Bauch reagiert oft als Erstes auf Stress – das ist ein klares Signal deines Nervensystems.'
          );
        }
        const emp = root.querySelector('[data-empathy-q5]');
        if (emp) emp.innerHTML = empText;
        showScreen('ease-quiz-screenQ5');
        updateProgress(5);
        trackDashboardStep('q5');
      } else if (q === 5) {
        sels.forEach((s) => {
          state.score += 1;
        });
        showScreen('ease-quiz-screenQ6');
        updateProgress(6);
        trackDashboardStep('q6');
      }
    }

    root.querySelector('[data-multi-next="q4"]')?.addEventListener('click', () => submitMulti(4, cfg));
    root.querySelector('[data-multi-next="q5"]')?.addEventListener('click', () => submitMulti(5, cfg));

    root.querySelector('[data-einblick1-next]')?.addEventListener('click', () => {
      showScreen('ease-quiz-screenQ4');
      updateProgress(5);
      trackDashboardStep('q4');
    });
    root.querySelector('[data-einblick2-next]')?.addEventListener('click', () => {
      showScreen('ease-quiz-screenQ7');
      updateProgress(8);
      trackDashboardStep('q7');
    });

    function startLoading(cfg) {
      const loadingScreen = root.querySelector('[data-loading-screen]');
      const loadingChecklist = root.querySelector('[data-loading-checklist]');
      const loadingAlmost = root.querySelector('[data-loading-almost]');
      const bar = root.querySelector('[data-loading-bar-inner]');
      const loadingStepsEl = root.querySelector('[data-loading-steps]');
      const lt = root.querySelector('[data-loading-title]');

      if (loadingStepsEl) {
        const stepsList = buildLoadingSteps();
        loadingStepsEl.innerHTML = stepsList.map((t, i) => renderLoadingStepMarkup(t, i)).join('');
      }
      if (lt) {
        const shortProfiles = {
          schlaf: 'Schlaf',
          unruhe: 'Stress',
          verspannung: 'Verspannungs',
          erschoepfung: 'Erschöpfungs',
          konzentration: 'Reizüberflutungs',
          angst: 'Anspannungs',
        };
        const q1 = state.answers[1];
        const profileShort = quizCopy(`loadingProfileShort.${q1}`, shortProfiles[q1] || shortProfiles.default || 'Stress');
        lt.textContent = quizCopy('loadingTitleTemplate', `Dein ${profileShort}-Profil wird erstellt…`, { profile: profileShort });
      }

      loadingScreen?.classList.remove(
        'ease-quiz-loading-screen--checklist-exit',
        'ease-quiz-loading-screen--almost-in',
        'ease-quiz-loading-screen--exiting'
      );
      bar?.classList.remove('ease-quiz-loading-bar--pulse');
      loadingChecklist?.removeAttribute('hidden');
      if (loadingAlmost) loadingAlmost.hidden = true;

      showScreen('ease-quiz-screenLoading');
      updateProgress(9);
      trackDashboardStep('loading');

      const steps = root.querySelectorAll('.ease-quiz-loading-step');
      const baseMsPerStep = [1200, 2400, 700, 1950];
      const jitter = (base) => base + Math.round(Math.random() * 480 - 120);

      let i = 0;
      function nextStep() {
        if (i > 0) {
          steps[i - 1]?.classList.remove('ease-quiz-loading-step--active');
          steps[i - 1]?.classList.add('ease-quiz-loading-step--done');
          const ic = steps[i - 1]?.querySelector('.ease-quiz-ls-icon');
          if (ic) ic.innerHTML = '✓';
        }
        if (i < steps.length) {
          steps[i]?.classList.add('ease-quiz-loading-step--active');
          if (bar) bar.style.width = ((i + 1) / steps.length) * 100 + '%';
          const wait = jitter(baseMsPerStep[i] ?? 1300);
          i++;
          setTimeout(nextStep, wait);
        } else {
          finishLoadingAndGoToEmail();
        }
      }

      function finishLoadingAndGoToEmail() {
        if (bar) {
          bar.style.width = '100%';
          bar.classList.add('ease-quiz-loading-bar--pulse');
        }

        loadingScreen?.classList.add('ease-quiz-loading-screen--checklist-exit');

        window.setTimeout(() => {
          loadingChecklist?.setAttribute('hidden', '');
          if (loadingAlmost) loadingAlmost.hidden = false;
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              loadingScreen?.classList.add('ease-quiz-loading-screen--almost-in');
            });
          });

          window.setTimeout(() => {
            loadingScreen?.classList.add('ease-quiz-loading-screen--exiting');
            window.setTimeout(() => {
              showEmailGate(cfg);
              loadingScreen?.classList.remove(
                'ease-quiz-loading-screen--checklist-exit',
                'ease-quiz-loading-screen--almost-in',
                'ease-quiz-loading-screen--exiting'
              );
              bar?.classList.remove('ease-quiz-loading-bar--pulse');
              loadingChecklist?.removeAttribute('hidden');
              if (loadingAlmost) loadingAlmost.hidden = true;
            }, 620);
          }, 1200);
        }, 900);
      }

      setTimeout(nextStep, 520);
    }

    function showEmailGate(cfg) {
      const maxScore = 28;
      state.stressLevel = Math.min(Math.round((state.score / maxScore) * 100), 100);
      const emailScreen = root.querySelector('.ease-quiz-email-screen');
      emailScreen?.classList.remove('ease-quiz-email-screen--enter');

      showScreen('ease-quiz-screenEmail');
      updateProgress(9);
      trackDashboardStep('email');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          emailScreen?.classList.add('ease-quiz-email-screen--enter');
        });
      });

      const bar = root.querySelector('[data-stress-meter-bar]');
      const label = root.querySelector('[data-stress-meter-label]');
      const sms = quizUiEn?.copy?.stressMeterShort;
      let color, text;
      if (state.stressLevel < 30) {
        color = '#2D6A4F';
        text = sms?.low || 'Leicht';
      } else if (state.stressLevel < 55) {
        color = '#ff9a73';
        text = sms?.medium || 'Mittel';
      } else if (state.stressLevel < 80) {
        color = '#ff7f51';
        text = sms?.elevated || 'Erhöht';
      } else {
        color = '#E74C3C';
        text = sms?.high || 'Hoch';
      }
      setTimeout(() => {
        if (bar) {
          bar.style.width = state.stressLevel + '%';
          bar.style.background = color;
        }
        if (label) {
          label.textContent = quizCopy('stressMeterLabel', `${text} (${state.stressLevel}%)`, {
            pct: String(state.stressLevel),
          });
          label.style.color = color;
        }
      }, 300);

      const q1 = state.answers[1];
      const teaserMap = {
        default: 'Dein Nervensystem zeigt deutliche Überlastungszeichen.',
        schlaf: 'Dein Nervensystem kommt abends nicht zur Ruhe – das beeinflusst deinen gesamten Schlafzyklus.',
        unruhe: 'Dein Nervensystem steckt im Dauerstress-Modus – daher das ständige Gedankenkreisen.',
        verspannung: 'Dein Körper trägt die Anspannung, die dein Kopf nicht loslässt – besonders in Nacken und Kiefer.',
        erschoepfung: 'Dein Nervensystem läuft auf Hochtouren, obwohl du erschöpft bist – ein klassisches Überlastungsmuster.',
        konzentration: 'Dein Nervensystem ist überstimuliert – darum bleibt kein Platz für klare Gedanken und Fokus.',
        angst: 'Angst und Anspannung schalten oft den Alarm-Modus hoch – Körper und Kopf sind dann permanent wach.',
      };
      const teaser = quizCopy(`emailTeasers.${q1}`, teaserMap[q1] || teaserMap.default);
      const tl = root.querySelector('[data-teaser-line]');
      if (tl) tl.textContent = teaser;

      const trigger = state.answers.trigger;
      const tried = state.multiSelections[5] || [];
      const blur1El = root.querySelector('[data-blur1]');
      const blur2El = root.querySelector('[data-blur2]');
      const blur3El = root.querySelector('[data-blur3]');
      const patternEcho = EINBLICK1_LIBRARY.q1_echo[q1] || quizUiEn?.yourPattern || 'dein Muster';
      const blur1 = quizCopy('emailBlur1', `Deine 3 Punkte für <strong>${patternEcho}</strong>: KG17, ${blurPoint2(q1)}…`, {
        pattern: patternEcho,
        point: blurPoint2(q1),
      });
      const timeEcho = EINBLICK2_LIBRARY.time_label[trigger] || quizCopy('individually', 'individuell');
      const blur2 = quizCopy('emailBlur2', `⏰ Anwendung <strong>${timeEcho}</strong>…`, { time: timeEcho });
      const triedList = tried
        .filter((t) => t !== 'nichts')
        .map((t) => EINBLICK2_LIBRARY.tried_echo[t])
        .filter(Boolean)
        .join(' + ');
      const blur3 =
        tried.filter((t) => t !== 'nichts').length > 0
          ? quizCopy('emailBlur3Tried', `Warum <strong>${triedList}</strong> bisher nicht reichten…`, { list: triedList })
          : quizCopy('emailBlur3Default', 'Dein 2-Minuten-Reset für den Alltag…');
      if (blur1El) blur1El.innerHTML = blur1;
      if (blur2El) blur2El.innerHTML = blur2;
      if (blur3El) blur3El.innerHTML = blur3;
    }

    function buildTags() {
      const base = (cfg.baseTags || '').trim();
      const parts = base ? base.split(',').map((t) => t.trim()).filter(Boolean) : [];
      parts.push('nervensystem-quiz-done');
      parts.push('quiz_v3');
      parts.push('stress-' + state.stressLevel);
      if (state.answers[1]) parts.push('symptom-' + state.answers[1]);
      if (state.answers.trigger) parts.push('trigger-' + state.answers.trigger);
      if (state.answers[3]) parts.push('dauer-' + state.answers[3]);
      const tried = state.multiSelections[5] || [];
      tried.filter((t) => t !== 'nichts').forEach((t) => parts.push('probiert-' + t));
      if (state.answers[7]) parts.push('wunsch-' + state.answers[7]);
      return [...new Set(parts)].join(', ');
    }

    function sendQuizWebhook(email) {
      const rawUrl = String(cfg.quizWebhookUrl || '').trim();
      if (!rawUrl) return;

      let webhookUrl;
      try {
        webhookUrl = new URL(rawUrl, window.location.origin).href;
      } catch (err) {
        return;
      }

      const payload = {
        source: 'ease-nervensystem-quiz',
        sectionId: sid || '',
        submittedAt: new Date().toISOString(),
        pageUrl: window.location.href,
        email: email || '',
        stressLevel: state.stressLevel,
        tags: buildTags(),
        answers: { ...state.answers },
        multiSelections: { ...state.multiSelections },
      };

      const body = JSON.stringify(payload);
      try {
        if (navigator.sendBeacon) {
          const blob = new Blob([body], { type: 'application/json' });
          if (navigator.sendBeacon(webhookUrl, blob)) return;
        }
      } catch (err) {}

      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
        mode: 'no-cors',
      }).catch(() => {});
    }

    function handleCustomerSubmit(e) {
      const marketing = form.querySelector('[data-quiz-marketing]');
      const emailSub = root.querySelector('[data-email-sub]');
      const submitBtn = form?.querySelector('[type="submit"]');
      const baseEmailSub = cfg?.email?.sub || '';

      function showSubmitError(msg) {
        if (emailInput) emailInput.style.borderColor = '#E74C3C';
        if (emailSub) {
          emailSub.textContent = msg;
          emailSub.style.color = '#E74C3C';
        }
      }

      if (marketing && !marketing.checked) {
        e.preventDefault();
        marketing.focus();
        showSubmitError(quizCopy('emailCheckboxRequired', 'Bitte bestätige die Checkbox, um fortzufahren.'));
        return;
      }
      const email = emailInput?.value.trim();
      if (!email || !email.includes('@')) {
        e.preventDefault();
        if (emailInput) {
          emailInput.style.borderColor = '#E74C3C';
          emailInput.placeholder = quizCopy('emailPlaceholderInvalid', 'Bitte gültige E-Mail eingeben');
        }
        return;
      }

      if (emailInput) emailInput.style.borderColor = '';
      if (emailSub) {
        emailSub.textContent = baseEmailSub;
        emailSub.style.color = '';
      }
      if (tagsInput) tagsInput.value = buildTags();

      if (!form) {
        e.preventDefault();
        showResults(cfg);
        return;
      }

      submitBtn?.setAttribute('disabled', 'disabled');
      if (emailInput) emailInput.value = email;
      const submitTargetName = `EaseQuizSubmitTarget-${sid || 'default'}`;
      let submitTarget = root.querySelector(`[data-quiz-submit-target="${submitTargetName}"]`);
      if (!submitTarget) {
        submitTarget = document.createElement('iframe');
        submitTarget.name = submitTargetName;
        submitTarget.setAttribute('data-quiz-submit-target', submitTargetName);
        submitTarget.setAttribute('hidden', '');
        submitTarget.setAttribute('aria-hidden', 'true');
        submitTarget.style.display = 'none';
        root.appendChild(submitTarget);
      }

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        submitBtn?.removeAttribute('disabled');
        sendQuizWebhook(email);
        sendDashboardSubmission(email);
        showResults(cfg);
        try {
          sessionStorage.setItem(sessionKey + ':done', '1');
        } catch (err) {}
      };

      try {
        submitTarget.addEventListener('load', finish, { once: true });
        setTimeout(finish, 2200);
        form.setAttribute('target', submitTargetName);
      } catch (err) {
        console.error('EASE Quiz lead submit', err);
        finish();
      }
    }

    function showResults(cfg) {
      showScreen('ease-quiz-screenResult');
      trackDashboardStep('result');
      const circle = root.querySelector('[data-result-circle]');
      let bg, headline, sub;
      const res = quizUiEn?.copy?.results;
      if (state.stressLevel < 30) {
        bg = 'linear-gradient(135deg, #2D6A4F, #52B788)';
        headline = res?.low?.headline || 'Leichte Belastung';
        sub = res?.low?.sub || 'Dein Nervensystem ist weitgehend im Gleichgewicht – mit gezielter Akupressur kannst du das erhalten.';
      } else if (state.stressLevel < 55) {
        bg = 'linear-gradient(135deg, #ff9a73, #ff7f51)';
        headline = res?.medium?.headline || 'Mittlere Belastung';
        sub = res?.medium?.sub || 'Dein Nervensystem zeigt erste Überlastungszeichen. Jetzt ist ein guter Zeitpunkt, aktiv gegenzusteuern.';
      } else if (state.stressLevel < 80) {
        bg = 'linear-gradient(135deg, #ff7f51, #f05a2a)';
        headline = res?.high?.headline || 'Erhöhte Belastung';
        sub = res?.high?.sub || 'Dein Nervensystem ist deutlich überfordert. Gezielte Vagusnerv-Stimulation kann hier den Unterschied machen.';
      } else {
        bg = 'linear-gradient(135deg, #C0392B, #E74C3C)';
        headline = res?.severe?.headline || 'Hohe Belastung';
        sub = res?.severe?.sub || 'Dein Nervensystem braucht dringend Unterstützung. Die gute Nachricht: Mit den richtigen Punkten kannst du sofort starten.';
      }
      if (circle) {
        circle.style.background = bg;
        circle.textContent = state.stressLevel + '%';
      }
      const h = root.querySelector('[data-result-headline]');
      const s = root.querySelector('[data-result-sub]');
      if (h) h.textContent = headline;
      if (s) s.textContent = sub;

      const pts = getRecommendedPoints(cfg);
      const container = root.querySelector('[data-points-container]');
      const pdb = { ...DEFAULT.pointsDB, ...(cfg.pointsDB || {}) };
      const images = cfg.pointImages || {};
      if (container) {
        container.innerHTML = '';
        pts.forEach((key) => {
          const p = pdb[key];
          if (!p) return;
          const card = document.createElement('div');
          card.className = 'ease-quiz-point-card';
          const imgUrl = images[key];
          const iconHtml = imgUrl
            ? `<span class="ease-quiz-point-icon ease-quiz-point-icon--img"><img src="${imgUrl}" alt="" loading="lazy" width="72" height="72"></span>`
            : `<span class="ease-quiz-point-icon">${iconSvg(p.icon)}</span>`;
          card.innerHTML = `${iconHtml}<div><div class="ease-quiz-point-name">${p.name}</div><div class="ease-quiz-point-desc">${p.location} – ${p.desc}</div></div>`;
          container.appendChild(card);
        });
      }

      const recapEl = root.querySelector('[data-result-recap-text]');
      if (recapEl) recapEl.innerHTML = buildRecapText();

      const socialEl = root.querySelector('[data-result-socialproof-text]');
      if (socialEl) socialEl.innerHTML = buildSocialProof(state.answers[1]);

      const trigger = state.answers.trigger;
      const timeBox = root.querySelector('[data-result-time-box]');
      const timeDetail = root.querySelector('[data-result-time-detail]');
      if (timeBox && timeDetail) {
        const timeText = TIME_BOX_TEXTS[trigger];
        if (timeText) {
          timeBox.hidden = false;
          timeDetail.textContent = timeText;
        } else {
          timeBox.hidden = true;
        }
      }

      const safetyEl = root.querySelector('[data-result-safety]');
      if (safetyEl) safetyEl.hidden = state.stressLevel < 80;

      renderOffer(cfg);
    }

    root.querySelector('[data-quiz-close]')?.addEventListener('click', closeModal);
    root.querySelector('[data-quiz-overlay]')?.addEventListener('click', closeModal);
    banner?.addEventListener('click', () => openModal(false));
    editorBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openModal(true);
    });
    root.querySelector('[data-quiz-intro-cta]')?.addEventListener('click', () => {
      showScreen('ease-quiz-screenQ1');
      updateProgress(1);
      trackDashboardStep('q1');
    });

    form?.addEventListener('submit', handleCustomerSubmit, { capture: true });

    renderIntro();
    bindQuestions();

    const resultCta = root.querySelector('[data-result-cta-link]');
    if (resultCta) {
      resultCta.addEventListener('click', (e) => {
        e.preventDefault();
        renderOffer(cfg);
        showScreen('ease-quiz-screenOffer');
        updateProgress(10);
        trackDashboardStep('offer');
      });
    }

    if (isPageLayout) {
      if (!state.sessionId) state.sessionId = generateSessionId();
      if (designMode && previewStep && previewStep !== 'closed') {
        applyPreviewStep();
      } else {
        resetQuizFlow();
      }
    } else if (designMode) {
      if (previewStep && previewStep !== 'closed') {
        openModal(true);
      }
    } else {
      const shouldAutoOpen = cfg.autoPopupEnabled === true;
      let t = null;
      if (shouldAutoOpen) {
        t = setTimeout(() => {
          if (sessionStorage.getItem(sessionKey)) return;
          sessionStorage.setItem(sessionKey, '1');
          openModal(false);
        }, delayMs);
      }
      root.addEventListener(
        'ease-quiz:cancel-delay',
        () => {
          if (t) clearTimeout(t);
        },
        { once: true }
      );
      banner?.addEventListener(
        'click',
        () => {
          root.dispatchEvent(new CustomEvent('ease-quiz:cancel-delay'));
        },
        { capture: true }
      );
    }

  }

  function boot() {
    document.querySelectorAll('[data-ease-quiz-root]').forEach(init);
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target && event.target.closest ? event.target.closest('[data-ease-quiz-open]') : null;
    if (!trigger) return;
    const root = document.querySelector('[data-ease-quiz-root]');
    if (!root || typeof root.__easeQuizOpen !== 'function') return;
    event.preventDefault();
    root.__easeQuizOpen();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (ev) => {
    const t = ev.target;
    if (!t || typeof t.querySelectorAll !== 'function') return;
    t.querySelectorAll('[data-ease-quiz-root]').forEach(init);
  });
})();
